import { Directive, Output, OnInit, OnDestroy, EventEmitter, Renderer2, ElementRef, AfterViewInit, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
    selector: '[directive-image-preload]',
})
export class ImagePreloadDirective implements OnInit, OnDestroy, AfterViewInit, OnChanges {
    private _target: HTMLElement;
    private _init: boolean = false;
    private _tempImg!: HTMLImageElement;

    @Input() public url: string;
    @Input() public background: boolean = false;
    @Output() public onLoaded: EventEmitter<Event> = new EventEmitter();

    constructor(
        private _renderer2: Renderer2,
        private _elementRef: ElementRef,
    ) { }

    ngOnInit(): void {
        this._target = this._elementRef.nativeElement;

    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.url && changes.url.previousValue !== changes.url.currentValue) {
            this._triggerLoading();
        }
    }


    ngAfterViewInit(): void {
        this._init = true;

        this._triggerLoading();
    }

    private _tempHide(): void {
        if (this.url && this._target && !this.background) {
            this._renderer2.setStyle(this._target, 'visibility', 'hidden');
            this._renderer2.setStyle(this._target, 'opacity', 0);
            this._renderer2.setStyle(this._target, 'transition', 'opacity .5s ease');
        }
    }

    private _triggerLoading(): void {
        if (!this.url || !this._init) return;
        this._tempHide();

        this._tempImg = this._renderer2.createElement('img');

        this._tempImg.onload = (event: Event) => {
            if(!this.background) {
                this._renderer2.setStyle(this._target, 'opacity', 0);
                this._renderer2.setAttribute(this._target, 'src', this.url);
                this._renderer2.setStyle(this._target, 'visibility', null);
                setTimeout(() => {
                    this._renderer2.setStyle(this._target, 'opacity', 1);

                    this.onLoaded.emit(event);

                    setTimeout(() => {
                        this._renderer2.setStyle(this._target, 'opacity', null);
                        this._renderer2.setStyle(this._target, 'transition', null);
                    }, 501);
                }, 50);
            } else {
                this._renderer2.setStyle(this._target, 'backgroundImage', `url(${this.url})`);
            }
        };

        this._renderer2.setAttribute(this._tempImg, 'src', this.url);
    }

    ngOnDestroy(): void {
        this._tempImg = null;
    }
}
